// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "meta.proto" (package "rs.devtools.meta", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Metadata } from "./meta";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppMetadata } from "./meta";
import type { AppMetadataRequest } from "./meta";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rs.devtools.meta.Metadata
 */
export interface IMetadataClient {
    /**
     * @generated from protobuf rpc: GetAppMetadata(rs.devtools.meta.AppMetadataRequest) returns (rs.devtools.meta.AppMetadata);
     */
    getAppMetadata(input: AppMetadataRequest, options?: RpcOptions): UnaryCall<AppMetadataRequest, AppMetadata>;
}
/**
 * @generated from protobuf service rs.devtools.meta.Metadata
 */
export class MetadataClient implements IMetadataClient, ServiceInfo {
    typeName = Metadata.typeName;
    methods = Metadata.methods;
    options = Metadata.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAppMetadata(rs.devtools.meta.AppMetadataRequest) returns (rs.devtools.meta.AppMetadata);
     */
    getAppMetadata(input: AppMetadataRequest, options?: RpcOptions): UnaryCall<AppMetadataRequest, AppMetadata> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppMetadataRequest, AppMetadata>("unary", this._transport, method, opt, input);
    }
}
